export function Legal({ legal }) {
  const link = legal.links[0];
  return(
    <div>
      <p className="has-text-centered has-text-grey">
        <small className="is-size-7">
          { legal.text }
          <a href={link.url} className="has-text-grey" target="_blank">
            {link.service}
          </a>
        </small>
      </p>
    </div>
  );
}